import React, { useState } from 'react';
import MainMenu from './ui/MainMenu';
import GameWrapper from './ui/GameWrapper';
import './App.css';

/**
 * App — Root component
 *
 * Simple phase management:
 * - 'menu' → MainMenu
 * - 'playing' → GameWrapper (canvas + engine)
 */

export default function App() {
  const [phase, setPhase] = useState('menu');

  const handleStart = (gameId) => {
    setPhase('playing');
  };

  const handleBack = () => {
    setPhase('menu');
  };

  return (
    <div className="app-root">
      {phase === 'menu' && <MainMenu onStart={handleStart} />}
      {phase === 'playing' && <GameWrapper onBack={handleBack} />}
    </div>
  );
}
